import './chatSlashCommandContentWidget.css.js';
import { Range } from 'monaco-editor/esm/vs/editor/common/core/range.js';
import { Disposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { localizeWithPath } from 'monaco-editor/esm/vs/nls.js';
import * as aria from 'monaco-editor/esm/vs/base/browser/ui/aria/aria.js';
class SlashCommandContentWidget extends Disposable {
    constructor(_editor) {
        super();
        this._editor = _editor;
        this._domNode = document.createElement('div');
        this._isVisible = false;
        this._domNode.toggleAttribute('hidden', true);
        this._domNode.classList.add('chat-slash-command-content-widget');
        this._register(this._editor.onKeyDown((e) => this._handleKeyDown(e)));
    }
    dispose() {
        this._editor.removeContentWidget(this);
        super.dispose();
    }
    show() {
        if (this._isVisible) {
            return;
        }
        this._isVisible = true;
        this._domNode.toggleAttribute('hidden', false);
        this._editor.addContentWidget(this);
    }
    hide() {
        this._isVisible = false;
        this._domNode.toggleAttribute('hidden', true);
        this._editor.removeContentWidget(this);
    }
    setCommandText(slashCommand) {
        this._domNode.innerText = `/${slashCommand} `;
        this._lastSlashCommandText = slashCommand;
    }
    getId() { return 'chat-slash-command-content-widget'; }
    getDomNode() { return this._domNode; }
    getPosition() { return { position: { lineNumber: 1, column: 1 }, preference: [0 ] }; }
    _handleKeyDown(e) {
        if (e.keyCode !== 1 ) {
            return;
        }
        const firstLine = this._editor.getModel()?.getLineContent(1);
        const selection = this._editor.getSelection();
        const withSlash = `/${this._lastSlashCommandText} `;
        if (!firstLine?.startsWith(withSlash) || !selection?.isEmpty() || selection?.startLineNumber !== 1 || selection?.startColumn !== withSlash.length + 1) {
            return;
        }
        this._editor.executeEdits('chat-slash-command', [{
                range: ( new Range(1, 1, 1, selection.startColumn)),
                text: null
            }]);
        aria.alert(( localizeWithPath(
            'vs/workbench/contrib/chat/browser/chatSlashCommandContentWidget',
            'exited slash command mode',
            'Exited {0} mode',
            this._lastSlashCommandText
        )));
    }
}
export { SlashCommandContentWidget };
